import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import { Home } from "../Pages/Home";
import { ProductDetails } from "../Pages/ProductDetails";
import { Shop } from "../Pages/Shop";
import { Cart } from "../Pages/Cart";
import { CheckOut } from "../Pages/CheckOut";
import { Login } from "../Pages/Login";
import { Singup } from "../Pages/Singup";
import { Protected } from "../Component/Protected";
import { OrderDetails } from "../Pages/OrderDetails";
import { AdminOrders } from "../Pages/AdminOrders";
import { AdminDashboard } from "../Pages/AdminDashboard";
import { AdminProducts } from "../Pages/AdminProducts";
import { AdminUsers } from "../Pages/AdminUsers";

export const Router = () => {
  const [isSignedIn, setIsSignedIn] = useState(
    sessionStorage.getItem("token") || false
  );

  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
          <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin-products" element={<AdminProducts />} />
        <Route path="/admin-users" element={<AdminUsers />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/product/:id" element={<ProductDetails />} />
          <Route path="/admin-orders" element={<AdminOrders />} />
          <Route path="/order-details/:id" element={<OrderDetails />} />
        <Route
          path="/cart"
          element={
            <Protected isSignedIn={isSignedIn}>
              <Cart />
            </Protected>
          }
        />
        <Route path="/login" element={<Login />} />
        <Route path="/singup" element={<Singup />} />
        <Route path="/checkout" element={
        <Protected isSignedIn={isSignedIn}>
        <CheckOut />
      </Protected>
        } />
      </Routes>
    </>
  );
};
